import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OnFocusDirective } from '@shared/directives/on-focus/on-focus.directive';
import { AuthorisationDirective } from './authorisation/authorisation.directive';
import { InAnswerSetRouteDirective } from './in-answer-set-route/in-answer-set-route.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    OnFocusDirective,
    AuthorisationDirective,
    InAnswerSetRouteDirective,
  ],
  exports: [
    OnFocusDirective,
    AuthorisationDirective,
    InAnswerSetRouteDirective
  ]
})
export class DirectivesModule { }
